import React, { useState } from "react";
import CustomModal from "./CustomModal";
import { deleteImg } from "assets/images";
import { Button, LoadingButton } from "components/form";
import { useTranslation } from "react-i18next";

const DeleteModal = ({ show, handleClose, deleteHandler, title, loader }) => {
  const { t } = useTranslation();
  return (
    <>
      <CustomModal show={show} handleClose={handleClose}>
        <div className="deleteModal">
          <img src={deleteImg} alt="" />
          <p>{title || t(`COMMON.areYouSure`)}</p>
          <div className="button_wrap">
            <LoadingButton
              className="light"
              onClick={deleteHandler}
              loading={loader}
            >
              {t(`COMMON.yes`)}
            </LoadingButton>
            <Button onClick={handleClose}>{t(`COMMON.no`)}</Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default DeleteModal;
